import { useState, useEffect } from 'react';
import Login from './Login';
import VenciAdmin from './VenciAdmin_v3';

const API_URL = "https://venci-backend-production.up.railway.app";

function App() {
  const [contador, setContador] = useState(null);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('venci_token');
    const contadorGuardado = localStorage.getItem('venci_contador');

    // Si viene de un pago exitoso de MP
    const params = new URLSearchParams(window.location.search);
    if (params.get('pago') === 'ok') {
      localStorage.removeItem('venci_token');
      localStorage.removeItem('venci_contador');
      window.location.href = '/';
      return;
    }

    if (token && contadorGuardado) {
      fetch(`${API_URL}/auth/me`, {
        headers: { Authorization: `Bearer ${token}` }
      })
        .then(r => {
          if (r.ok) return r.json();
          throw new Error('Token inválido');
        })
        .then(data => {
          // Siempre usar datos frescos del servidor, no del localStorage
          const ct = data.data;
          setContador(ct);
          // Actualizar localStorage con datos frescos
          localStorage.setItem('venci_contador', JSON.stringify(ct));

          // Acá se bloqueaba la cuenta entera y se mostraba la pantalla de
          // planes. Se sacó: el contador nunca se bloquea. Lo que vence es la
          // suscripción de CADA cliente, y ese cartel vive adentro de la ficha
          // del cliente, no acá.
          setCargando(false);
        })
        .catch(() => {
          localStorage.removeItem('venci_token');
          localStorage.removeItem('venci_contador');
          setContador(null);
          setCargando(false);
        });
    } else {
      setCargando(false);
    }
  }, []);

  const handleLogin = (contadorData) => {
    setContador(contadorData);
  };

  const handleLogout = () => {
    localStorage.removeItem('venci_token');
    localStorage.removeItem('venci_contador');
    setContador(null);
  };

  if (cargando) return null;
  if (!contador) return <Login onLogin={handleLogin} />;
  return <VenciAdmin contador={contador} onLogout={handleLogout} />;
}

export default App;
// rebuild trigger
